import FormReportsPage from '@/views/forms/FormReportsPage'
import FormLayout from '@/views/layouts/FormLayout'

export default function Page() {
  return (
    <FormLayout>
      <FormReportsPage />
    </FormLayout>
  )
}
